export const lengthTruncatedText = (text, length) =>
	text.length > length ? text.substring(0, length - 3) + '...' : text;

export const isEmptyText = (str) => !str || str.length === 0;
